import styled, { css } from 'styled-components';
import CoreScroll from '@nrk/core-scroll/jsx';
import { device } from '../breakpoints';
import ContentItem from '../ContentItem/ContentItem';
import ShowcaseCard from '../ShowcaseCard/ShowcaseCard';

export const Container = styled.div`
    position: relative;
`;

export const GAP = {
    DEFAULT: 5,
    GTE_MEDIUM: 5,
    GTE_XLARGE: 10,
    FULLSCREEN: 10,
};

export const NO_OF_ITEMS = {
    DEFAULT: 3,
    GTE_MEDIUM: 4,
    GTE_XLARGE: 5,
    FULLSCREEN: 6,
};

/**
 * Calculates the article with based on gap size and the number of visible items
 */
export const getArticleWidth = (gap, noOfItems, superSize = 1) => {
    /* 
        This should be subtracted from the article wih (multiply the number
        of visible gaps with gap size and divide it by the number of items)
    */
    const subtractWidth = ((noOfItems - 1) * gap) / noOfItems;

    if (superSize > 1) {
        return `calc((${100 / noOfItems}% * ${superSize}) - ${subtractWidth - 2}px)`;
    }

    return `calc((${100 / noOfItems}% * ${superSize}) - ${subtractWidth}px)`;
};

export const CoreCarousel = css`
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none; /* Firefox */

    /* Chrome, Safari & Opera */
    &::-webkit-scrollbar {
        display: none;
    }

    width: 100%;
    display: flex;

    /* transform: translateZ(
        0
    ); Promotes to new layer but causes extra memory usage.  Maybe not worth it */

    padding-top: 3px; /* Make space for item focus outline */
`;

const getWidthAndMargins = (superSize = 1) => css`
    margin-right: ${GAP.DEFAULT}px;
    max-width: ${getArticleWidth(GAP.DEFAULT, NO_OF_ITEMS.DEFAULT, superSize)};

    flex: 0 0 100%;

    .touchevents & {
        max-width: 43%;
        margin-right: 5px;
    }

    @media ${device.GteMedium} {
        margin-right: ${GAP.GTE_MEDIUM}px;
        max-width: ${getArticleWidth(GAP.GTE_MEDIUM, NO_OF_ITEMS.GTE_MEDIUM, superSize)};

        .touchevents & {
            max-width: 28.5%;
        }
    }

    @media ${device.GteXLarge} {
        margin-right: ${GAP.GTE_XLARGE}px;
        max-width: ${getArticleWidth(GAP.GTE_XLARGE, NO_OF_ITEMS.GTE_XLARGE, superSize)};
    }

    @media ${device.FullScreen} {
        margin-right: ${GAP.FULLSCREEN}px;
        max-width: ${getArticleWidth(GAP.FULLSCREEN, NO_OF_ITEMS.FULLSCREEN, superSize)};
    }

    &:last-of-type {
        ${superSize < 2 &&
        css`
            margin-right: 0;
        `}
    }
`;

export const CarouselArticle = css`
    ${getWidthAndMargins()}
`;

export const BannerContainer = styled.div`
    ${getWidthAndMargins(2)}
`;

export const CarouselContentItem = styled(ContentItem)`
    ${getWidthAndMargins(1)}
`;

export const CarouselShowcaseCard = styled(ShowcaseCard)`
    ${getWidthAndMargins(1)}
`;

export const StyledCarousel = styled(CoreScroll)`
    ${CoreCarousel}
`;

export const TouchDeviceCarousel = styled.div`
    ${CoreCarousel}
`;
